import config from '../config/config.js';
import axios from 'axios';

const { baseUrl } = config;

export const checkCityExistence = async city => {
  const endpoint = `${baseUrl}/v1/city/check-existence?city=${city}`;
  return await axios.get(endpoint);
};
